import { useAuth } from '../hooks/useAuth'
import { route } from 'preact-router'

export function LogoutButton() {
  const { logout } = useAuth()

  const handleLogout = () => {
    logout()
    route('/')
  }

  return (
    <button
      onClick={handleLogout}
      className="px-2 py-1 md:px-3 md:py-1.5 text-xs md:text-sm text-slate-400 hover:text-white hover:bg-slate-700 rounded-md transition-colors"
    >
      Logout
    </button>
  )
}
